import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=d6cfecd6"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=d6cfecd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Share: require('/workspace/components/Share.vue').default,FaqCardPost: require('/workspace/components/FaqCardPost.vue').default,EventCardGeneral: require('/workspace/components/EventCardGeneral.vue').default})
